import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DESC_ENTITY } from '@constants/desc-entity';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { EntityModel } from '@data-layer/models/entities';

@Component({
  selector: 'isf-summary-details',
  templateUrl: './isf-summary-details.component.html',
  styleUrls: ['./isf-summary-details.component.scss'],
})
export class IsfSummaryDetailsComponent implements OnInit {
  @Input() public isfEntitySum: { code: enumEntityModelCode; isfEntity: EntityModel | EntityModel[] };
  @Input() public canEdit: boolean = true;
  @Input() public canRemove: boolean;
  @Input() public showHtsDescription = false;

  @Output() public entityCodeEdit: EventEmitter<string> = new EventEmitter<string>();
  @Output() public entityRemove: EventEmitter<void> = new EventEmitter<void>();

  public isMissing = false;
  public isAttention = false;
  public isfEntity: EntityModel;
  public isfEntities: EntityModel[];
  public isArray = false;

  public info = null;
  public enumEntityModelCode: typeof enumEntityModelCode = enumEntityModelCode;

  constructor() {}

  public ngOnInit(): void {
    this.info = DESC_ENTITY[this.isfEntitySum.code];

    this.isArray = Array.isArray(this.isfEntitySum.isfEntity);
    if (!this.isArray) {
      this.isMissing = !this.isfEntitySum.isfEntity;
      this.isfEntity = this.isfEntitySum.isfEntity as EntityModel;
    } else {
      this.isfEntities = this.isfEntitySum.isfEntity as EntityModel[];
      if (this.isfEntitySum.code === enumEntityModelCode.STAFFING_LOCATION || this.isfEntitySum.code === enumEntityModelCode.CONSOLIDATOR) {
        this.isAttention = !this.isfEntities.length;
      }

      this.isMissing = !this.isAttention && !this.isfEntities.length;
    }
  }

  public gotoEdit() {
    this.entityCodeEdit.emit(this.isfEntitySum.code);
  }
}
